import React from "react";
import { HiOutlineTrash } from "react-icons/hi";

export default function DeleteBtn(props) {
  return (
    <>
      <button
        // disabled={props.isLoading}
        className={`button is-small modal-button ${
          props.isLoading ? "is-loading" : ""
        }`}
        onClick={!props.isLoading && props.deleteContent}
      >
        <span className="icon is-small has-text-danger">
          <HiOutlineTrash className="fas fa-2x" />
        </span>
      </button>
    </>
  );
}
